import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';
import { StudentDocumentVaultResponse } from '../../models/student-document-vault/student-document-vault';

export interface RequestMissingDocumentRequest {
  studentId: string;
  title: string;
  category: number;
  remarks?: string;
  instituteId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OperationsService {
  constructor(private genericService: GenericService) {}

  /**
   * Fetches document vault for a specific student (Operations view)
   */
  getStudentDocumentVault(studentId: string, pageNumber: number = 1, pageSize: number = 10, category?: number, statusFilter: number = 1, sortField?: string, sortOrder?: number): Observable<apiResponse<StudentDocumentVaultResponse[]>> {
    const params: any = { 
      studentId,
      pageNumber: pageNumber?.toString() ?? '1', 
      pageSize: pageSize?.toString() ?? '10',
      statusFilter: statusFilter?.toString() ?? '1'
    };
    if (category) {
      params.category = category.toString();
    }
    if (sortField && sortField.trim() !== '') {
      params.sortField = sortField;
      params.sortDirection = sortOrder === 1 ? 'asc' : 'desc';
    }
    // Assuming operations uses this endpoint or a similar one with studentId
    return this.genericService.get('operations/student/document-vault', { params });
  }

  /**
   * Returns category counts for a specific student
   */
  getStudentCategoryCounts(studentId: string, statusFilter: number = 1): Observable<apiResponse<any[]>> {
    return this.genericService.get(`operations/student/document-vault/category-counts`, { params: { studentId, statusFilter: statusFilter.toString() } });
  }

  /**
   * Requests a missing document from a student
   */
  requestMissingDocument(request: RequestMissingDocumentRequest): Observable<any> {
    return this.genericService.post('operations/student/document-vault/request-missing', request);
  }

  /**
   * Fetches full details of a specific document
   */
  getDocumentById(id: string, studentId: string): Observable<apiResponse<StudentDocumentVaultResponse>> {
    return this.genericService.get(`student/document-vault/${id}`, { params: { studentId } });
  }

  /**
   * Fetches status counts (Uploaded vs Missing) for a student
   */
  getStudentDocumentVaultStatusCounts(studentId: string): Observable<apiResponse<any>> {
    return this.genericService.get('student/document-vault/status-counts', { params: { studentId } });
  }
}
